import {calcSimplePoints} from "../_common/pointsCalculationHelper";

export const calculatePoints = calcSimplePoints